import { isSupportedCountry } from "react-phone-number-input";

const TIMEZONE_COUNTRY_MAP = {
  "Asia/Kolkata": "IN",
  "Asia/Calcutta": "IN",
  "Asia/Dubai": "AE",
  "Asia/Singapore": "SG",
  "Asia/Tokyo": "JP",
  "Asia/Shanghai": "CN",
  "Asia/Hong_Kong": "HK",
  "Europe/London": "GB",
  "Europe/Paris": "FR",
  "Europe/Berlin": "DE",
  "America/New_York": "US",
  "America/Chicago": "US",
  "America/Denver": "US",
  "America/Los_Angeles": "US",
  "America/Toronto": "CA",
  "Australia/Sydney": "AU",
};

export const normalizeCountryCode = (code) => {
  const normalized = String(code || "").trim().toUpperCase();
  return isSupportedCountry(normalized) ? normalized : null;
};

export const getTimezoneCountry = () => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return normalizeCountryCode(TIMEZONE_COUNTRY_MAP[timezone]);
  } catch (error) {
    return null;
  }
};

export const getInitialCountry = () => getTimezoneCountry() || "IN";

const fetchJson = async (url) => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Request failed: ${response.status}`);
  }
  return response.json();
};

const locationProviders = [
  async () => {
    const data = await fetchJson("https://ipapi.co/json/");
    return data.country_code || data.country;
  },
  async () => {
    const data = await fetchJson("https://get.geojs.io/v1/ip/country.json");
    return data.country;
  },
  async () => {
    const data = await fetchJson("https://ipwho.is/");
    return data.country_code;
  },
  async () => {
    const response = await fetch("https://www.cloudflare.com/cdn-cgi/trace");
    if (!response.ok) {
      throw new Error(`Request failed: ${response.status}`);
    }
    const trace = await response.text();
    const locationLine = trace
      .split("\n")
      .find((line) => line.startsWith("loc="));
    return locationLine?.split("=")[1];
  },
];

const getUserLocation = async () => {
  for (const provider of locationProviders) {
    try {
      const countryCode = normalizeCountryCode(await provider());
      if (countryCode) {
        return { countryCode };
      }
    } catch (error) {
      // Try the next provider.
    }
  }

  const timezoneCountry = getTimezoneCountry();
  if (timezoneCountry) {
    return { countryCode: timezoneCountry };
  }

  return { countryCode: "IN" };
};

export default getUserLocation;
